import api from "./apiSmartLogistics.js";

export default {
  GetUsers() {
    return api.get("users/GetUsers");
  },

  GetUser(Id) {
    return api.get("users/GetUser/" + Id);
  },

  InsertUsers(user) {
    return api.post("users/InsertUsers", user);
  },

  UpdateUser(user) {
    return api.put("users/UpdateUser", user);
  },

  SearchUsers(value) {
    return api.get("users/SearchUsers/" + value);
  },

  GetUserCustomer(email) {
    return api.get("users/GetUserCustomers/" + email);
  },

  GetUserOperations(email) {
    return api.get("users/GetUserOperations/" + email);
  },

  GetUserExtractions(email) {
    return api.get("users/GetUserExtractions/" + email);
  }
};
